<meta name="description" content="شركة كودس روتس هي شركة متخصصه في تصميم المواقع وتطبيقات الجوال نتميز بفريق تسويق خبرة في مجال التسويق الاكتروني واشهار المواقع والسيو ومسك الكلمات وعمل خطط تسويقيه كامله">
<meta property="og:description" content="شركة كودس روتس هي شركة متخصصه في تصميم المواقع وتطبيقات الجوال نتميز بفريق تسويق خبرة في مجال التسويق الاكتروني واشهار المواقع والسيو ومسك الكلمات وعمل خطط تسويقيه كامله">
<meta property="og:site_name" content="Codesroots">
<meta name="twitter:card" content="summary"><meta name="twitter:description" content="شركة كودس روتس هي شركة متخصصه في تصميم المواقع وتطبيقات الجوال نتميز بفريق تسويق خبرة في مجال التسويق الاكتروني واشهار المواقع والسيو ومسك الكلمات وعمل خطط تسويقيه كامله">
<meta name="keywords" content="تسويق الكتروني-حملات جوجل اد ورد-جوجل سيو">

<marketing-service></marketing-service>
<ads-section></ads-section>
<marketing-why-codesroots></marketing-why-codesroots>
<div class="container-fluid">
    <app-fatc-boxes [facts]='facts'></app-fatc-boxes>
</div>